<form [formGroup]="ivrDonationDetailForm" novalidate (ngSubmit)="save()" *ngIf="ivrDonationDetail">
    <div class="modal-header">
        <h1>עריכת פרטי תרומה טלפונית [{{ (id > 0 ? id : 'חדש') }}] </h1>
    </div>
    <div class="modal-body">.
        <div *ngIf="ivrDonationDetail" class="example-form">
            <div class="col-sm-12">
                <fieldset class="form-group" fxLayout="column">
                    <legend>פרטי תרומה</legend>
                    <div class="form-row" fxLayout="row" fxLayout.xs="column">
                        <div style="width: 250px !important;" class="input-group mb-3">
                            <label>שם איש:</label>
                            <h3> {{ ivrDonationDetail.firstName }} {{ ivrDonationDetail.lastName }}</h3>
                        </div>
                    </div>

                    <div class="form-row" fxLayout="row" fxLayout.xs="column">
                      <div class="input-group mb-3">
                        <label>קטגוריה...</label>
                        <mat-select class="form-control" placeholder="קטגוריה..." formControlName="donationCategoryID">
                          <mat-option value=""></mat-option>
                          <mat-option *ngFor="let c of  servicesData.DonationCategories" [value]="c.id">
                            {{c.title}}
                          </mat-option>
                        </mat-select>
                    </div>
                  </div>
                    <div class="form-row" fxLayout="row" fxLayout.xs="column">
                      <date-input  [placeholder]="'תאריך טיפול'" [dateControl]="ivrDonationDetailForm.controls.handlingDate">Loading...
                      </date-input>
                  </div>

                </fieldset>
            </div>
        </div>
    </div>
    <footer-edit-buttons [dataProvider]="ivrDonationDetailsData" [router]="router" [id]="id" [disabledDeleteButton]="id <= 0"
        [modelFormGroup]="ivrDonationDetailForm"></footer-edit-buttons>
</form>
